var exports = {
  "kL": "xdde3148b--74eb2f--container",
  "Sl": "xdde3148b--74eb2f--image",
  "DD": "xdde3148b--74eb2f--title",
  "nf": "xdde3148b--74eb2f--link",
};

module.exports = exports;
